import { lazy } from "react";

export { NOTIFICATION_TEMPLATE_LIST_PATH } from "./notification-template-list-path";
export const NotificationTemplateListPage = lazy(
  () => import("./notification-template-list"),
);
